export default function useCreativeReportsPageAccess() {
  return true
}
